import React, {
    Component
} from 'react';
import './App.css';
import Menu from './Search/Menu/Menu'
import Results from './Components/Results'
import DownloadCSVModal from './Components/DownloadCSVModal/DownloadCSVModal'

//require('dotenv').config();


class App extends Component {
    constructor(props) {
        super(props);
        this.setState = this.setState.bind(this);
		this.hostname = process.env.API_HOSTNAME || "//ordtidni.arnastofnun.is"
//		this.hostname = process.env.API_HOSTNAME || "http://malheildir.arnastofnun.is:3001"
//        this.hostname = process.env.REACT_APP_API_HOSTNAME || "http://127.0.0.1:3000"
        this.hitsPerPage = 100;
        this.state = {
            error: false,
            loading: false,
            totalLoading: false,
            activeQuery: "",
            downloadCSVModal: false
        };
    }

    updateIfEqual = (stateVal, qVal, newState) => {
        if (stateVal === qVal) {
            this.setState(newState)
        } else {
            //console.log("Expired API call");
        }
    }

    openCsvModal = () => this.setState({downloadCSVModal: true});
    closeCsvModal = () => this.setState({downloadCSVModal: false})
    getTotalPages = () => Math.floor(this.state.totalRows/this.hitsPerPage) + 1


    handleMakeSearchQuery = (apiUrl) => {
        // if (apiUrl === this.state.activeQuery) return this.setState({currentPage: 1, listData: this.state.resultPages[1]})
        this.setState({error: false, activeQuery: apiUrl})
    }

    handleGetNumberOfRows = (apiUrl) => {
        this.handleMakeSearchQuery(apiUrl + '&getTotalRows=true')
    }

    menuSelect = (apiUrl, options) => {
        const opts = Object.keys(options)
        const querystring = "?" + opts
            .filter((opt) => (typeof(options[opt]) === 'boolean' && options[opt])
                || options[opt].length || (typeof(options[opt]) === 'number' && options[opt] > 0 ))
            .map((opt) => {
                return (typeof(options[opt]) === 'boolean'
                    ? options[opt] ? opt : ''
					: (opt + '=' + (Array.isArray(options[opt]) ? options[opt].map(item => item.value ? item.value : item) : options[opt])))
//					: (opt + '=' + options[opt]))
            })
            .join('&');
        this.setState({activeQuery: apiUrl + querystring})
    }

    render() {
        return (
            <div>
				<header className="header" >
					<div className="header-content">

						<h1>
							<a href="http://www.arnastofnun.is/">
								<img src="/img/sam_logo.svg" className="logo" />
							</a>

							<span>Orðtíðnivefur Árnastofnunar</span>
							<span><small>Stofnun Árna Magnússonar í íslenskum fræðum</small></span>
						</h1>

						<div className="topnav">
							<a className="active" href="/">Heim</a>
							<a href="/about">Um vefinn</a>
						</div>

					</div>
				</header>

                <div className="content">
                    <Menu
                        onSelect={this.menuSelect}
                        options={this.state.options}
                        changeSearchTerm={this.handleChangeSearchTerm}
                        searchHandler={this.handleMakeSearchQuery}
                        />
                    <DownloadCSVModal
                        show={this.state.downloadCSVModal}
                        modalClosed={this.closeCsvModal}
                        activeQuery={this.state.activeQuery}
                        hostname={this.hostname}
                        confirm={() => {this.closeCsvModal()}}
                        cancel={() => {this.closeCsvModal()}}
                        />
                    <Results
                        openDownloadModal={this.openCsvModal}
                        activeQuery={this.state.activeQuery}
                        hostname={this.hostname}
                        />
                </div>
                <footer>Stofnun Árna Magnússonar í íslenskum fræðum</footer>
            </div>
        );
    }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js